<template lang="pug">
  v-container(grid-list-lg fluid style='height:100%;')
    vue-headful(:title="componentConfig.branding.title('Page not found')")
    v-layout.align-center(fill-height)
      v-flex
        .text-center
          .text-h3.primary--text Whoops, 404
          .text-body-1.mt-2 The page you were looking for does not exist
          v-btn.mt-8(outlined color="primary" to="/") Get me out of here!
</template>

<script>
import componentConfigService from '@/services/componentConfig'
export default {
  computed: {
    componentConfig () {
      return componentConfigService(this.$store.getters['user/isForAdServer'])
    }
  }
}
</script>
